export enum RecurrenceRule {
  Event = 'EVENT',
  Recurring = 'RECURRING'
}
